import { useState } from "react"
import { callApi } from "../../libs"

const useRewards = () => {
    const [reward, setReward] = useState({ isErr: true, status: 500, data: null, statusCode: "STAND_BY" })

    const getRewardList = () => {
        const url = `${process.env.REACT_APP_API_COVID19_BACKOFFICE}/api/rewards/by-token`
        const method = 'get'
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("actk")}`
        }
        callApi(method, url, null, { headers })
            .then(res => {
                // console.log(res)
                let newReward = res
                setReward({
                    ...reward,
                    status: newReward.status,
                    msg: newReward.msg,
                    data: newReward.data,
                    statusCode: "GET_REWARDLIST_SUCCESS"
                })
            })
            .catch(error => {
                setReward({
                    ...reward,
                    status: error.status,
                    statusCode: "GET_REWARDLIST FAIL",
                    data: error
                })
            })
    }

    const redeemRewardById = (rewardNumber) => {
        const url = `${process.env.REACT_APP_API_COVID19_BACKOFFICE}/api/rewards/redeem`
        const method = 'put'
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("actk")}`
        }
        const body = {
            rewardNumber
        }
        // console.log(reward)
        callApi(method, url, body, { headers })
            .then(res => {
                console.log(res)
                let newReward = { ...reward }
                newReward.isErr = false
                newReward.status = res.status
                newReward.data = res.data
                newReward.statusCode = "REDEEM_REWARD_SUCCESS"
                setReward(newReward)
            }).catch(error => {
                if (error.status === 400) {
                    setReward({
                        ...reward,
                        data: { msg: "ส่วนลดไม่ถูกต้อง หรือใช้ไปแล้ว" },
                        statusCode: "REDEEM_DUPLICATEREWARD_FAIL"
                    })
                } else {
                    setReward({
                        ...reward,
                        statusCode: "REDEEM_REWARD_FAIL"
                    })
                }
            })
    }

    return {
        reward,
        setReward,
        getRewardList,
        redeemRewardById
    }
}

export default useRewards